"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Animated = _interopRequireDefault(require("react-native-web/dist/exports/Animated"));

var _quarkCore = require("quark-core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoaderBubbles =
/*#__PURE__*/
function (_React$Component) {
  _inherits(LoaderBubbles, _React$Component);

  function LoaderBubbles(props) {
    var _ref;

    var _this;

    _classCallCheck(this, LoaderBubbles);

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_ref = LoaderBubbles.__proto__ || Object.getPrototypeOf(LoaderBubbles)).call.apply(_ref, [this, props].concat(args))); // create an animated value we will modify

    _this.state = {
      radii: _toConsumableArray(new Array(props.nBubbles)).map(function () {
        return new _Animated.default.Value(2 * _this.props.radius);
      })
    };
    return _this;
  }

  _createClass(LoaderBubbles, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.state.radii.map(function (animatedValue, i) {
        _Animated.default.loop(_Animated.default.sequence([_Animated.default.timing(animatedValue, {
          toValue: 0,
          duration: 500
        }), _Animated.default.timing(animatedValue, {
          toValue: 2 * _this2.props.radius,
          duration: 500
        })])).start();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          r = _props.radius,
          nBubbles = _props.nBubbles;
      return _react.default.createElement(_quarkCore.FlexRow, {
        alignItems: "center",
        justifyContent: "space-around",
        style: {
          height: 2 * r,
          width: 2 * nBubbles * r + (nBubbles - 1) * this._gap
        }
      }, this.state.radii.map(function (_, i) {
        return _react.default.createElement(_Animated.default.View, {
          key: i,
          style: {
            borderRadius: '50%',
            width: _this3.state.radii[0],
            height: _this3.state.radii[0],
            backgroundColor: _this3.props.color
          }
        });
      }));
    }
  }, {
    key: "_gap",
    get: function get() {
      return 2 * this.props.radius;
    }
  }]);

  return LoaderBubbles;
}(_react.default.Component);

LoaderBubbles.defaultProps = {
  nBubbles: 3,
  color: '#000000',
  radius: 15
};
var _default = LoaderBubbles;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/quark-core/components/loaders/Bubbles.js
// module id = ./node_modules/quark-core/components/loaders/Bubbles.js
// module chunks = 0